// extracted by mini-css-extract-plugin
export var discard = "_4j-3";
export var muiTooltipTooltip = "_4j-5";
export var notificationBar = "_4j-2";
export var saveButtonHoverSlotWrapper = "_4j-4";
export var show = "_4j-1";
export var spacer = "_4j-0";